// removed by extract-text-webpack-plugin
module.exports = {"container":"_1MyCHdav1KDLIqK3j9SBhR","input":"_3PLtfws8_FtgKPVuiL5dSK"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/dashboard/pages/DashboardPage.scss
// module id = 655
// module chunks = 0